import BaseAPI, { ApiResponse } from '../BaseAPI'
import { SsuRunDTO } from './SsurunDTO'
import { mapSsuRunDtoToSsuRun } from './SsurunMapper'
import { SsuRun } from './SsurunModel'

/**
 * Gets a list of SsuRun Ids for a given sample
 * @param sampleId The sample Id
 * @returns A list of SsuRun Ids
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function getSsuRunIds(sampleId: string): Promise<ApiResponse<string[]>> {
    // ToDo: Hardcoded for testing purposes. Remove after more data is made available
    const sampleIdMOck = 'C0000019'
    const response = await BaseAPI.getMany<string>('/ssurun/id', sampleIdMOck)
    const response2 = await BaseAPI.getMany<string>('/ssurun/id', 'C0000037')

    if (response.errors && response.errors.code === '404') {
        return {
            succeeded: true,
            data: [],
        }
    }

    return {
        ...response,
        data: [...response.data, ...response2.data],
    }
}

/**
 * Gets the SsuRun data from a given ssuRunId
 * @param ssuRunId The ssuRunId
 * @returns The ssuRun model
 */
export async function getSsuRun(ssuRunId: string): Promise<ApiResponse<SsuRun>> {
    const response = await BaseAPI.get<SsuRunDTO>('/ssurun/ssu-id', ssuRunId)

    const ssuRunModel = response.data && mapSsuRunDtoToSsuRun(response.data)
    return {
        ...response,
        data: ssuRunModel,
    }
}
